import { isNil } from "./isNil-n-HZ9AXW.mjs";

//#region src/isNotNil.ts
/**
* Check if a value is not undefined or null
* @category Type Guards
* @example
* ```ts twoslash
* import { isNotNil } from '@simplisafe/ewok'
*
* isNotNil(null) // => false
* isNotNil(undefined) // => false
* isNotNil('') // => true
* isNotNil(0) // => true
* isNotNil([]) // => true
* isNotNil({}) // => true
* ```
*/
function isNotNil(val) {
	return !isNil(val);
}
var isNotNil_default = isNotNil;

//#endregion
export { isNotNil_default };